import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { SocialsService } from '../socials.service';
import { SocialAuthModel, SocialKind } from '../socials.model';
import { GoogleAuthService } from './google-auth.service';
import { GoogleUserProfile } from './google-sdk';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EComService } from '@src/app/ecom-services/ecom-common.service';
@Component({
  selector: 'app-google-login',
  templateUrl: './google-auth.component.html',
  styleUrls: ['./google-auth.component.css']  // Add this line
})
export class GoogleAuthComponent implements OnInit, AfterViewInit, OnDestroy {
  userProfile: GoogleUserProfile | any | null;
  loggedIn = false;
  private popupWindow: Window | null = null;
  private ngUnsubscribe = new Subject();
  constructor(private _authService: GoogleAuthService,
    private _socialGlobal: SocialsService,
  public ecomservice: EComService) {
    //Hand 
    window.addEventListener('message', this.handleMessage.bind(this));
    this._authService.authStatus
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (profile: GoogleUserProfile) => {
        if (profile) {
          this.loggedIn = true;
          this.userProfile = profile;  // update the user profile after login
          await this.loadingData(profile);
        } else {
          this.loggedIn = false;
          console.log("google logout");
          this._socialGlobal.authObjectSubject.next(null);  // Reset the authObjectSubject when logout
        }
      });
  }
  ngOnInit() {
  }
  ngOnDestroy() {
    this.ngUnsubscribe.complete();
    window.removeEventListener('message', this.handleMessage.bind(this));
  }
  private async handleMessage(event: MessageEvent) {
    // Verify the origin of the message
    if (event.origin !== window.location.origin) return;

    if (event.data.type === 'AUTH_SUCCESS') {
      // Update the BehaviorSubject with data from the popup 
      const callBackInfo = event.data.authBack;
      // console.log('call back close:',callBackInfo);
      await this._authService.handleLoginCallback(callBackInfo);
    }
  }
  public avartarLoadError(event: any) {
    console.log('error loading img', event)
  }
  private async loadingData(profile: any) {
    const socialProfile: SocialAuthModel = { AuthId: profile.sub ? profile.sub : '', Email: profile.email ? profile.email : '', FirstName: profile.given_name ? profile.given_name : '', LastName: profile.family_name ? profile.family_name : '', UserFullName: profile ? profile.name : '' };
    // console.log('next object all auth',socialProfile);
    this._socialGlobal.authObjectSubject.next({ KindId: SocialKind.Google, UserInfo: socialProfile });
  }

  ngAfterViewInit() {

  }
  public showLogin() {
    // const testcall:GoogleUserProfile  = {sub:'iiii', email:'kkk', email_verified:true,family_name:'mi',given_name:'isme', locale:'', name:'name',picture:'00', updated_at:null,zoneinfo:'11'}
    // this.loadingData(testcall);
    // return;
    // Open the popup window to start the Google OAuth process.
    const urlStartAuth = `${window.location.origin}/${this.ecomservice.GetOlarConfigValue('PREFIX_ROUTING')}google/callback`;
    // console.log(_constants.PREFIX_ROUNTING,urlStartAuth);
    this.popupWindow = window.open(urlStartAuth, 'Google Login', 'width=600,height=600,scrollbars=yes');
  }
  login(): void {
    this._authService.login();
  }

  logout(): void {
    this._authService.logout();
  }

}